const CONST = {
  
  MATERIAL:{
    RED: "red",
    GREEN: "green",
    BLUE: "blue"
  }
}

export default CONST;
